import { TableActionsButton, type TableActionsButtonProps } from './TableActionsButton';

export function TableActionsInline({ buttons }: { buttons: TableActionsButtonProps[] }) {
    const renderedButtons = buttons
        .filter((button) => button.visible !== false)
        .map((button) => <TableActionsButton {...button} key={button.id} />);

    return <div className='flex flex-row justify-center gap-1'>{renderedButtons}</div>;
}
